import { render, staticRenderFns } from "./Messagebar.vue?vue&type=template&id=2cda82eb&"
import script from "./Messagebar.vue?vue&type=script&lang=js&"
export * from "./Messagebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports